<template functional>
    <span class="fa-stack fa-lg">
        <i class="fa fa-circle fa-stack-1x stack-background"/>
        <i class="fas fa-magic fa-stack-1x" />
    </span>
</template>

<script>
    export default {
        name: 'touchpoint-overview-icon-magic'
    }
</script>

<style scoped src="../../../Style/touchpoint-overview-icon-magic.scss" lang="scss"/>